module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLightIt.d58266f9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-ExtraLightIt.ttf
// module id = 322
// module chunks = 3